import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import ConfigProvider from '../../config-provider';
import { obj } from '../../util';

// 文字头像
class TextAvatar extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'small', 'medium', 'large', 'xl']),
    style: PropTypes.object,
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    colorSets: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
    colorSets: ['#BC61CF', '#F26666', '#F29A52', '#F4C329', '#CBD057', '#289ED3', '#29B3F0'],
    style: {},
  }

  getBgColor = () => {
    const { text, colorSets } = this.props;
    if (typeof text !== 'string' || colorSets.length === 0 || colorSets.length === 1) {
      return '#289ED3';
    }
    const charCode = text.charCodeAt(0);
    const len = colorSets.length;
    const index = charCode % len;
    return colorSets[index];
  }

  render() {
    const { prefix, size, style, className, text, ...others } = this.props;
    return (
      <div
        style={{ background: this.getBgColor(), ...style }}
        className={cls({
          [`${prefix}avatar-text`]: true,
          [className]: !!className,
          [`${prefix}avatar-text-${size}`]: true,
        })}
        {...obj.pickAttrs(others)}
      >
        {text}
      </div>
    );
  }
}

export default ConfigProvider.config(TextAvatar);
